import type { LoaderFunctionArgs } from 'react-router';

import type { Standards } from '@ifs-gcp/core';
import type { AuditTemplateRoot, StartProcessTemplateRoot } from '@ifs-gcp/core/models';

import { loadJsonTemplate } from '@/hooks/useJsonTemplate';
import {
  type AvailableActionsResponse,
  fetchAvailableActions,
} from '@/queries/get-available-actions';
import { fetchModulesInUse } from '@/queries/get-modules-in-use';
import type { ModulesInUseResponse } from '@/types';
import { loadAndProcessModules } from '@/utils/processModules';

export type DashboardLoaderData = {
  standards: Standards;
  dashboardTemplate: AuditTemplateRoot;
  startProcessTemplate: StartProcessTemplateRoot;
  modulesInUse: ModulesInUseResponse;
  availableActions: AvailableActionsResponse;
};

export async function dashboardLoader({
  params,
}: LoaderFunctionArgs): Promise<DashboardLoaderData> {
  const supplierId = params.supplier_id;

  if (!supplierId) {
    throw new Error('Supplier id is missing');
  }

  const [standards, dashboardTemplate, startProcessTemplate, modulesInUse, availableActions] =
    await Promise.all([
      loadAndProcessModules(),
      loadJsonTemplate<AuditTemplateRoot>('AXPX_ONLINE_DASHBOARD'),
      loadJsonTemplate<StartProcessTemplateRoot>('AXPX_AUDIT_ONLINE_START_GENERAL'),
      fetchModulesInUse(supplierId),
      fetchAvailableActions(supplierId),
    ]);

  return {
    standards,
    dashboardTemplate,
    startProcessTemplate,
    modulesInUse,
    availableActions,
  };
}
